package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.Node
import org.w3c.dom.events.Event


@Composable
fun TextArea(
    value: String,
    onValueChange: (String) -> Unit,
    editorRef: ((HTMLDivElement?) -> Unit)? = null,
    onSelectionChange: (() -> Unit)? = null,
    backgroundColor: com.varabyte.kobweb.compose.ui.graphics.Color.Rgb
) {
    var divRef by remember { mutableStateOf<HTMLDivElement?>(null) }

    Div(
        attrs = {
            attr("contenteditable", "true")
            attr("placeholder", "Commencez à rédiger ici...")
            style {
                property("min-height", "140px")
              //  property("width", "100%")
                property("outline", "none")
                property("background-color", backgroundColor)
                property("white-space", "pre-wrap")
                property("word-break", "break-word")
                property("overflow-wrap", "break-word")
                property("font-family", INTER)
            }

            ref { element ->
                editorRef?.invoke(element)
                if (element.innerHTML != value) {
                    element.innerHTML = value
                }

                val selectionHandler: (Event) -> Unit = {
                    val sel = window.asDynamic().getSelection()
                    if (sel != null && (sel.rangeCount as Int) > 0) {
                        val range = sel.getRangeAt(0).asDynamic()
                        val ancestor = range.commonAncestorContainer
                        if (element.contains(ancestor as? Node)) {
                            onSelectionChange?.invoke()
                        }
                    }
                }

                document.addEventListener("selectionchange", selectionHandler)

                onDispose {
                    editorRef?.invoke(null)
                    document.removeEventListener("selectionchange", selectionHandler)
                }
            }

            addEventListener("input") { event ->
                val html = (event.target as? HTMLDivElement)?.innerHTML ?: ""
                onValueChange(html)
            }

            addEventListener("keyup") { onSelectionChange?.invoke() }
            addEventListener("mouseup") { onSelectionChange?.invoke() }
        }
    )
}